import styled, {css} from "styled-components";

const DeliveryManagerMobileStyled = styled.div`
    position: absolute;
    overflow: hidden;
    top: 0;
    right: -110%;
    opacity: 0;
    width: 0;
    height: 100%;
    z-index: 99;
    background: white;
    transition: all 0.1s ease-in-out;
    margin-top: 6rem;   

${props => {
        return (
            props.deliveryManagerExist &&
            css`
                  right: 0;
                  opacity: 1;
                  width: 100%;
            `
        );
    }}
`;

export { 
	DeliveryManagerMobileStyled
 };
